exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2O5dlw3eDS6f7P{margin-top:8px}._3kCCOQvfOk0X0S{margin-bottom:16px}._3kCCOQvfOk0X0S svg{display:block;margin-bottom:16px}._35OKKdPuRd_8r6{margin:0 0 8px 20px}", ""]);

// exports
exports.locals = {
	"contentSkeletonContainer": "_2O5dlw3eDS6f7P",
	"cardSkeleton": "_3kCCOQvfOk0X0S",
	"titleSkeleton": "_35OKKdPuRd_8r6"
};